/**
 * Route patterns for telemetry.
 *
 * A span or metric attribute must never carry the concrete URL: `/project/42`
 * and `/project/7` are the same route, and one series per project page makes
 * the Metrics page unusable (official RUM web-vitals guidance). This collapses
 * ids, uuids and slugs-shaped segments to `:id` and drops the query string,
 * which is also where preview and revalidation tokens live.
 *
 * @module lib/observability/routes
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC = /^\d+$/
/** A long, dash-joined slug is a CMS slug, not a route segment. */
const SLUG = /^[0-9a-z]+(?:-[0-9a-z]+){2,}$/i

/**
 * `/project/my-remodel-2026-01` -> `/project/:id`; `/blog/hello` stays as it is
 * (a two-word slug is more likely a static path than an id).
 */
export function toRoutePattern(input: string): string {
  let path = input
  try {
    path = new URL(input, 'http://localhost').pathname
  } catch {
    const cut = input.search(/[?#]/)
    path = cut === -1 ? input : input.slice(0, cut)
  }
  const segments = path.split('/').map((segment) => {
    if (segment === '') return segment
    if (UUID.test(segment) || NUMERIC.test(segment) || SLUG.test(segment)) return ':id'
    return segment
  })
  const collapsed = segments.join('/')
  return collapsed === '' ? '/' : collapsed
}
